<div mat-dialog-title class="flex flex-row items-center justify-between border-b border-gray-200 px-6 py-2 mb-4">
  <h3 class="flex-1 m-0 font-semibold">{{'media.createMedia' | translate}}</h3>
  <flow-button class="absolute right-4 top-3" theme="light" type="button" (onClick)="onCancel()">
    <app-icon stroke="#202020" size="md" iconName="x"></app-icon>
  </flow-button>
</div>
<mat-dialog-content class="overflow-hidden">
  <div class="h-full flex-col justify-start items-start gap-10 inline-flex">
    <form [formGroup]="form">
      <div class="w-full flex-col justify-center items-start gap-4 flex">
        <div class="justify-start items-start gap-2 inline-flex">
          <mat-checkbox formControlName="isClientBoxChecked" color="primary"></mat-checkbox>
          <div class="text-gray-900 text-[0.75rem] font-normal">{{'createMedia.moveClientMediaToFolder' | translate}}</div>
        </div>
        <div class="input-dimensions">
          <mat-label>{{'media.form.name' | translate}} *</mat-label>
          <mat-form-field class="w-full">
            <input matInput type="text" formControlName="name" />
          </mat-form-field>
        </div>
        <div class="input-dimensions">
          <mat-label>{{ 'media.form.client' | translate }}</mat-label>
          <mat-form-field class="w-full">
            <mat-select
              formControlName="clientId"
              placeholder="{{'media.form.clientPlaceholder' | translate}}"
              (selectionChange)="getDataByClient($event.value)">
              <mat-option *ngFor="let client of clients" [value]="client.id">{{ client.name | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="input-dimensions">
          <flow-form-input formControlName="price" label="media.form.price" type="number"></flow-form-input>
        </div>
        <div class="input-dimensions">
          <flow-form-select-currency
            formControlName="currency"
            [options]="currencies"
            [label]="'client.form.currency'"
            [placeholder]="'createClient.placeholder.addCurrency'"
            [required]="true"></flow-form-select-currency>
        </div>
        <div class="input-dimensions">
          <flow-form-select
            formControlName="pricingModel"
            [label]="'global.pricingModel'"
            [options]="pricingModels"
            [multiple]="false"
            [required]="true"></flow-form-select>
        </div>
        <div class="input-dimensions">
          <mat-label>{{ 'media.form.tags' | translate }}</mat-label>
          <mat-form-field class="w-full">
            <flow-multi-select-autocomplete
              formControlName="tags"
              [options]="tags"
              [displayFn]="displayTag"
              [newOptionFn]="newTag"></flow-multi-select-autocomplete>
          </mat-form-field>
        </div>
        <div class="input-dimensions">
          <flow-form-input formControlName="description" label="media.form.description" [maxLength]="50"></flow-form-input>
        </div>
        <div class="input-dimensions">
          <flow-form-input formControlName="intendedTargetGroups" label="media.form.targetGroup" [maxLength]="50"></flow-form-input>
        </div>
        <div class="input-dimensions">
          <flow-form-input formControlName="author" label="media.form.author" [maxLength]="50"></flow-form-input>
        </div>
        <div class="input-dimensions">
          <flow-form-input formControlName="brand" label="media.form.brand" [maxLength]="50"></flow-form-input>
        </div>
        <div class="input-dimensions">
          <flow-form-input formControlName="skuArticleNumbers" label="media.form.sku" [maxLength]="50"></flow-form-input>
        </div>
        <div
          class="flex flex-row w-full justify-start items-end gap-2  cursor-pointer"
          [ngClass]="{'opacity-50 pointer-events-none': data.isDefault && mediasArray.length > 0}">
          <flow-drag-to-upload
            class="w-full"
            [supportedFileTypes]="supportedFileTypes"
            (selectedFile)="selectFile($event)"
            [reset]="reset"></flow-drag-to-upload>
          <flow-button theme="primary" (onClick)="isEdit ? saveFile() : addFile()" [disabled]="!selectedFile || !form.valid">
            <app-icon stroke="#fafafa" size="md" [iconName]="selectedFile && form.valid || isEdit ? 'checked' : 'plus'"></app-icon>
          </flow-button>
        </div>

        <div class="flex flex-col w-full max-h-40 overflow-y-auto gap-4" *ngIf="mediasArray?.length > 0">
          <flow-media-upload-item
            *ngFor="let media of mediasArray; let i = index"
            [media]="media"
            [uploadingDone]="uploadingDone"
            [selectedMedia]="selectedFile"
            [mediaIndex]="i"
            (edit)="editFile(media)"
            (remove)="removeFile(media.id)"></flow-media-upload-item>
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>
<div mat-dialog-actions class="flex flex-row justify-between w-full items-center p-6 pt-3">
  <flow-button theme="secondary" variation="outline" (onClick)="onCancel()">{{ 'global.cancel' | translate }}</flow-button>
  <flow-button theme="primary" [disabled]="disableUpload || mediasArray.length === 0" (onClick)="onSave()">
    {{ 'global.add' | translate }}
  </flow-button>
</div>
